/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  display: inline-block;
  margin: 0 calc(20rem/14) calc(8rem/14) 0;
  outline: none;
}
:host > .wrapper {
  display: -webkit-box;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: flex-start;
  -webkit-box-align: center;
          align-items: center;
  width: 100%;
}
:host > .wrapper > davinci-button {
  -webkit-box-flex: 0;
          flex: 0 1 auto;
  z-index: 2;
}
:host > .wrapper > davinci-button[disabled] {
  z-index: 0;
}
:host > .wrapper > davinci-button.decrease {
  -webkit-transform: translateX(1px);
          transform: translateX(1px);
}
:host > .wrapper > davinci-button.increase {
  -webkit-transform: translateX(-1px);
          transform: translateX(-1px);
}
:host > .wrapper > input {
  font-size: 14;
  -webkit-box-flex: 0;
          flex: 0 1 auto;
  height: calc(46rem/14 - (2 * 1px));
  min-width: calc(20rem/14 - (2 * 1px));
  width: 100%;
  padding: 0 calc(16rem/14);
  text-align: center;
  text-overflow: ellipsis;
  z-index: 1;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  border: 1px solid var(--davinci-color-text-disabled,#8999A4);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  outline: none;
}
:host > .wrapper > input:invalid {
  box-shadow: none;
}
:host > .wrapper > input::-ms-clear {
  display: none;
}
:host > .wrapper > input::-webkit-inner-spin-button {
  -webkit-appearance: none;
          appearance: none;
}
:host > .wrapper > input:focus {
  border: 1px solid var(--davinci-color-primary,#007CC1);
}
:host > .wrapper > .unit {
  padding-left: calc(12rem/14);
}

:host([disabled]) > .wrapper > input {
  color: #B4BEC5;
  color: var(--davinci-color-outline, #B4BEC5);
  border: 1px solid var(--davinci-color-outline-disabled,#D2D9DD);
  pointer-events: none;
}`;
export { style };
//# sourceMappingURL=NumericField.style.js.map